import request from '@/router/axios';

export function getCusListpage(obj) {
  return request({
    url: '/cus/page',
    method: 'POST',
    data: obj,
  });
}

/**
 *  获取动态表单回显值
 */
export function getDynamicFormValue(cusId) {
  return request({
    url: '/cus/getCusInfo/'+cusId,
    method: 'GET',
  });
}
/**
 *  查询客户信息
 */
export function getCusInfo() {
  return request({
    url: '/cus/getCusInfo',
    method: 'GET',
  });
}

/**
 *  根据id修改数据
 * @param obj
 */
export function updateListpage(obj) {
  return request({
    url: '/cus/update',
    method: 'put',
    data: obj,
  });
}

export function addListpage(obj) {
  return request({
    url: '/cus/add',
    method: 'post',
    data: obj,
  });
}
export function batchUpdateStatus(obj) {
  return request({
    url: '/cus/batchUpdate',
    method: 'post',
    data: obj,
  });
}
/**
 *  获取客户管理员信息
 */
export function getCusAdminInfo(id) {
  return request({
    url: '/cus/getCusAdminInfo/'+id,
    method: 'GET',
  });
}
//添加客户管理员
export function addCusAdminInfo(obj) {
  return request({
    url: '/cus/addAdmin',
    method: 'post',
    data: obj,
  });
}
//加载客户列表，用于下拉搜索
export function loadCusList() {
  return request({
    url: '/cus/loadCusList',
    method: 'GET',
  });
}


